
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.124 7.88c.054 2.276-1.74 4.177-4.019 4.232a4.12 4.12 0 01-4.229-4.014 4.133 4.133 0 014.019-4.233 4.12 4.12 0 014.229 4.014v0z","stroke":"#fff","stroke-width":"1.5","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M19.25 19.053s-3.694-4.661-8.25-4.661-8.25 4.661-8.25 4.661","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    